export const CREATE_DRAG_THRESHOLD_PX = 4;
export const MOVE_DRAG_THRESHOLD_PX = 4;
export const AUTO_PAN_EDGE_THRESHOLD_PX = 64;
export const AUTO_PAN_MAX_MS_PER_FRAME = 2.5 * 24 * 60 * 60 * 1000;
export const PENDING_ITEM_ID = '__pending_create__';
export const POINT_LABEL_MAX_WIDTH_PX = 220;
export const POINT_LABEL_SECTION_OFFSET_PX = 15;
export const ROW_HEIGHT_PX = 21;
export const TOUCH_PAN_THRESHOLD_PX = 5;
